import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

export interface CBQScenarioDTO {
  id: string;
  cbqExamId?: string;
  title: string | null;
  pdfS3Key: string | null;
  estimatedMinutes: number | null;
  sortKey?: string | null;
  order?: number | null;
  createdAt?: string;
  updatedAt?: string;
}

type InitCBQScenarioResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: CBQScenarioDTO;
};

export const InitCBQScenario = async (
  cbqExamId: string
): Promise<InitCBQScenarioResponse> => {
  try {
    const response = await axios.post(
      `/admin/cbq/exams/${cbqExamId}/scenarios/init`
    );
    // Endpoint wraps payload as { message, data: {...scenario} }
    return { data: response.data?.data ?? response.data };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
